"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _useProduct2 = require("@/hooks/use-product");
var _chooseGoods = _interopRequireDefault(require("../chooseGoods"));
var _priceSetting = require("@/api/priceSetting");
var _postcss = require("postcss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _useProduct = (0, _useProduct2.useProduct)(),
  productTypeList = _useProduct.productTypeList;
var _default = exports.default = {
  name: 'Adjustprice',
  components: {
    chooseGoods: _chooseGoods.default
  },
  props: {
    isApprove: {
      type: Boolean,
      required: false,
      default: false
    },
    isCreate: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var validateAdjustValue = function validateAdjustValue(rule, value, callback) {
      var num = Number(value);
      if (!num || num <= 0) {
        callback(new Error('请输入调整值'));
        return;
      }
      callback();
    };
    return {
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      constants: this.$constants,
      priceSourceOptions: [{
        label: '取竞品最低价',
        value: 'lowest_price'
      }, {
        label: '取竞品平均价',
        value: 'average_price'
      }, {
        label: '取京东价',
        value: 'jd_price'
      }, {
        label: '取淘宝价',
        value: 'taobao_price'
      }],
      reasonOptions: [{
        label: '成本变动',
        value: '成本变动'
      }, {
        label: '促销活动',
        value: '促销活动'
      }, {
        label: '市场调整',
        value: '市场调整'
      }, {
        label: '季节性调整',
        value: '季节性调整'
      }, {
        label: '其他',
        value: '其他'
      }],
      form: {
        adjustType: 'fixed_value',
        adjustPriceType: 'cost_base',
        adjustPriceSymbol: 'add',
        adjustPriceValue: 0,
        adjustTag: 'original_profit_amount',
        adjustReason: '',
        remark: '',
        applyMethod: 1,
        adjustTakePriceType: undefined
      },
      rules: {
        adjustBase: [{
          required: true,
          message: '请选择调整价格类型',
          trigger: 'change'
        }],
        adjustValue: [{
          validator: validateAdjustValue,
          trigger: 'blur'
        }],
        adjustReason: [{
          required: true,
          message: '请选择调价原因',
          trigger: 'change'
        }]
      },
      tableData: [],
      currenttable: [],
      selectedRows: [],
      chooseGoodsVisible: false,
      chooseGoodsList: [],
      chooseSelectedRows: [],
      recordVisible: false,
      recordData: {
        recordList: []
      },
      otherData: {
        approverName: '',
        applyTime: '',
        applicantName: '',
        approveTime: '',
        approveRemark: '',
        auditStatus: -1
      }
    };
  },
  computed: {
    isReadonly: function isReadonly() {
      return this.isCreate === 2;
    }
  },
  watch: {
    'editData.id': function editDataId(val) {
      if (!val) return;
      this.initEditData();
    }
  },
  mounted: function mounted() {
    if (this.editData && this.editData.id) this.initEditData();
  },
  methods: {
    searchPrice: (0, _validate.Debounce)(function () {
      var _this = this;
      console.log(this.form);
      if (this.currenttable.length > 0) {
        var ids = this.currenttable.map(function (item) {
          return item.specId;
        });
        var adjustTag = this.form.adjustTag;
        if (this.form.adjustPriceType === 'sale_base') {
          adjustTag = undefined;
        }
        (0, _priceSetting.getCalculatePriceList)({
          adjustTag: adjustTag,
          adjustType: this.form.adjustType,
          adjustPriceType: this.form.adjustPriceType,
          adjustPriceSymbol: this.form.adjustPriceSymbol,
          adjustPriceValue: this.form.adjustPriceValue,
          adjustTakePriceType: this.form.adjustTakePriceType,
          ids: ids,
          applyMethod: this.form.applyMethod
        }).then(function (res) {
          if (res && res.length > 0) {
            _this.currenttable = _this.currenttable.map(function (item) {
              var temp = res.find(function (temp) {
                return temp.id === item.specId;
              });
              temp && delete temp.id;
              return _objectSpread(_objectSpread({}, item), temp);
            });
          }
        });
      }
    }),
    paginate: function paginate(page, pageSize, data) {
      if (!Array.isArray(data)) {
        throw new TypeError('data 必须是一个数组');
      }
      var total = data.length;
      var totalPages = Math.ceil(total / pageSize);
      var currentPage = Math.min(Math.max(page, 1), totalPages);
      var start = (currentPage - 1) * pageSize;
      var end = start + pageSize;
      return {
        page: currentPage,
        pageSize: pageSize,
        total: total,
        totalPages: totalPages,
        list: data.slice(start, end)
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.currenttable = this.paginate(this.listPram.page, this.listPram.limit, this.tableData).list;
      this.searchPrice();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.currenttable = this.paginate(this.listPram.page, this.listPram.limit, this.tableData).list;
      this.searchPrice();
    },
    handlerAudit: function handlerAudit() {
      this.$emit('approveHandle', this.editData.id);
    },
    close: function close() {
      this.$emit('hideEditDialog');
    },
    initEditData: function initEditData() {
      var _this2 = this;
      if (this.isCreate === 0) return;
      (0, _priceSetting.adjustPriceDetail)({
        id: this.editData.id
      }).then(function (res) {
        if (!res) return;
        console.log(res);
        _this2.form = {
          adjustPriceSymbol: res.adjustPriceSymbol,
          adjustPriceType: res.adjustPriceType,
          adjustPriceValue: res.adjustPriceValue,
          adjustTag: res.adjustTag,
          adjustType: res.adjustType,
          adjustReason: res.adjustReason,
          remark: res.remark,
          applyMethod: res.applyMethod,
          adjustTakePriceType: res.adjustTakePriceType
        };
        _this2.tableData = res.detailList;
        _this2.currenttable = _this2.paginate(_this2.listPram.page, _this2.listPram.limit, res.detailList).list;
        _this2.otherData = {
          approverName: res.approverName,
          applyTime: res.applyTime,
          applicantName: res.applicantName,
          approveTime: res.approveTime,
          approveRemark: res.approveRemark,
          auditStatus: res.auditStatus
        };
      });
    },
    formatMoney: function formatMoney(value) {
      var num = Number(value);
      if (!Number.isFinite(num)) return '0.00';
      return num.toFixed(2);
    },
    getAdjustSign: function getAdjustSign() {
      return this.form.adjustDirection === 'sub' ? -1 : 1;
    },
    getAdjustPercentText: function getAdjustPercentText() {
      var sign = this.getAdjustSign() > 0 ? '+' : '-';
      return "".concat(sign).concat(this.formatMoney(this.form.adjustValue), "%");
    },
    getAdjustAmount: function getAdjustAmount(row) {
      var base = Number(row.latestPrice) || 0;
      var percent = (Number(this.form.adjustValue) || 0) / 100;
      var sign = this.getAdjustSign();
      return base * percent * sign;
    },
    getAdjustedPrice: function getAdjustedPrice(row) {
      var base = Number(row.latestPrice) || 0;
      return base + this.getAdjustAmount(row);
    },
    getAdjustColorClass: function getAdjustColorClass(row) {
      var amount = Number(row);
      if (amount > 0) return 'text-red-600';
      if (amount < 0) return 'text-green-600';
      return '';
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    openChooseGoods: function openChooseGoods() {
      this.chooseGoodsVisible = true;
    },
    handleGoodsSelection: function handleGoodsSelection(selectedGoods) {
      console.log('selectedGoods', this.tableData);
      if (!selectedGoods || selectedGoods.length === 0) {
        this.chooseGoodsVisible = false;
        return;
      }
      var tempSelectedGoods = _toConsumableArray(this.tableData);
      selectedGoods.forEach(function (item) {
        var flag = tempSelectedGoods.some(function (selectedItem) {
          return selectedItem.specId === item.specId;
        });
        if (!flag) {
          tempSelectedGoods.push(item);
        }
      });
      this.tableData = _toConsumableArray(tempSelectedGoods);
      this.currenttable = this.paginate(this.listPram.page, this.listPram.limit, this.tableData).list;
      this.searchPrice();
      this.chooseGoodsVisible = false;
    },
    handleBatchRemove: function handleBatchRemove() {
      if (this.selectedRows.length === 0) return;
      var removeKeySet = new Set(this.selectedRows.map(function (item) {
        return item.specId;
      }));
      this.tableData = this.tableData.filter(function (item) {
        return !removeKeySet.has(item.specId);
      });
      this.currenttable = this.paginate(this.listPram.page, this.listPram.limit, this.tableData).list;
      this.selectedRows = [];
    },
    removeRow: function removeRow(row) {
      this.tableData = this.tableData.filter(function (item) {
        return item.specId !== row.specId;
      });
      this.currenttable = this.paginate(this.listPram.page, this.listPram.limit, this.tableData).list;
    },
    openAdjustRecord: function openAdjustRecord(row) {
      var _this3 = this;
      (0, _priceSetting.adjustPriceRecord)(row.specId).then(function (res) {
        _this3.recordData = res;
      });
      this.recordVisible = true;
    },
    handlerSubmit: (0, _validate.Debounce)(function () {
      var _this4 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        var form = _objectSpread({}, _this4.form);
        if (_this4.tableData.length === 0) {
          _this4.$message.error('请选择调价商品');
          return;
        }
        var id = undefined;
        if (_this4.isCreate === 1) {
          id = _this4.editData.id;
        }
        if (form.adjustPriceType === 'sale_base') {
          form.adjustTag = undefined;
        }
        var params = _objectSpread(_objectSpread({}, form), {}, {
          adjustmentId: id,
          ids: _this4.tableData.map(function (item) {
            return item.specId;
          })
        });
        if (form.applyMethod === 4) {
          params = {
            adjustTakePriceType: form.adjustTakePriceType,
            adjustReason: form.adjustReason,
            remark: form.remark,
            adjustmentId: id,
            ids: _this4.tableData.map(function (item) {
              return item.specId;
            }),
            applyMethod: 4
          };
        }
        (0, _priceSetting.saveCalculatePriceList)(params).then(function (res) {
          _this4.$message.success('提交成功');
          _this4.close();
        });
      });
    })
  }
};